import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

// Attach token from localStorage on admin routes
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token && config.url && config.url.startsWith('/admin')) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getOgImage = (title, subtitle) => {
  const params = new URLSearchParams();
  if (title) params.set('title', title);
  if (subtitle) params.set('subtitle', subtitle);
  return `${API}/og?${params.toString()}`;
};
